import { useQuery } from '@tanstack/react-query';
import ApiConfig from 'src/config/api-config';

export interface ClientProfileTabResponse {
  status: string;
  data: {
    clientProfile: {
      fitnessLevel?: string | null;
      energyLevel?: string | null;
      activityLevel?: number | string | null;
      bodyProfile?: string;
      gender?: string;
    };
    injuriesAndNotes: {
      parts?: string[];
      notes?: string;
    };
    bodyMetrics: {
      waist: string;
      weight: string;
      chest: string;
      height: string;
      hip: string;
      bodyFat: string;
      arms: string;
      leanMass: string;
      thighs: string;
      age: string;
    };
    progressPhotos: {
      lastUpdated: string;
      photos: { type: 'front' | 'side' | 'back'; label: string; url: string | null }[];
    };
    movementProgression?: {
      baseValues: { mobility: number; stability: number; balance: number; quality: number }[];
      legendData: {
        key: string;
        label: string;
        color: string;
        status: string;
        trend: string;
        percentage: string;
      }[];
    } | null;
  };
}

const getClientProfileTab = async (
  clientId: string,
  trainerId?: string,
): Promise<ClientProfileTabResponse['data']> => {
  if (!clientId) {
    throw new Error('clientId is required');
  }

  let apiUrl = `${ApiConfig.CLOUD_FUNCTIONS_BASE_URL}${ApiConfig.TRAINER_GET_CLIENT_PROFILE_TAB}?clientId=${clientId}`;
  if (trainerId) {
    apiUrl += `&trainerId=${trainerId}`;
  }

  const response = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch client profile tab');
  }

  const data: ClientProfileTabResponse = await response.json();
  return data.data;
};

import { sessionStore } from 'src/store/sessionStore';

export const useGetClientProfileTab = (clientId: string) => {
  const { currentUser } = sessionStore();
  const trainerId = currentUser?.uid;

  return useQuery({
    queryKey: ['clientProfileTab', clientId],
    queryFn: () => getClientProfileTab(clientId, trainerId),
    enabled: !!clientId,
  });
};
